import type { Product } from '@/domains/productDiscovery/algolia/interfaces/product';

import type { WithSponsoredProduct } from '../interfaces/product';
import type { SponsoredProduct } from '../interfaces/sponsoredProduct';

interface ProductWithPosition extends Product, WithSponsoredProduct {
  position: number;
}

export const getSponsoredProductsDisplayed = (
  products: (Product & WithSponsoredProduct)[],
  sponsoredProductsConfig: SponsoredProduct[],
) =>
  products
    .reduce(
      (acc, product) => {
        if (product.isSponsored && product.position !== null) {
          const sponsoredProductInfo = sponsoredProductsConfig.find(
            (sp) => String(sp.productId) === product.productId,
          );

          if (sponsoredProductInfo) {
            acc.push({
              product: { ...product, position: product.position },
              sponsoredProductInfo,
            });
          }
        }
        return acc;
      },
      [] as {
        product: ProductWithPosition;
        sponsoredProductInfo: SponsoredProduct;
      }[],
    )
    .map(({ product, sponsoredProductInfo }) => ({
      product: {
        ...sponsoredProductInfo,
        brandId: product.brandId,
        brandName: product.brandName,
        price: product.prices.main || 0,
        sellerId: product.sellerId,
      },
      position: product.position,
    }));
